import type { DesignModels, ModelWithNetStats } from '@cadstrom/sigma-engine-shared';
import type { CommandBarProviderProps } from '#components/command-bar/command-bar-types.js';

export const MODULE_SEARCH_PREFIX = '$';
export const MODULE_SEARCH_PROVIDER_ID = 'module-search';

/**
 * Callback that is called when a module is selected in the module search provider.
 */
export type ModuleSearchProviderOnModuleSelectedCallback = (
	projectModule: DesignModels.ProjectModule,
	moduleReferenceDesignator: string,
) => void;

export interface ModuleSearchProviderProps extends CommandBarProviderProps {
	coreModel: ModelWithNetStats;
	onModuleSelected?: ModuleSearchProviderOnModuleSelectedCallback;
}
